import { useEffect, useState } from 'react'
// redux
import { useSelector } from 'react-redux'
// services
import NPSService from 'services/NPS'
// hooks
import useUIActions from './useUIActions'
// constants
import storageNames from 'constants/storageNames'

export default function useNPS() {
	// redux
	const {
		session: { userId }
	} = useSelector(state => state)

	// actions ui
	const { handleCloseModal, handleShowCloseIconModal } = useUIActions()

	// state
	const [NPSState, setNPSState] = useState({
		npsId: parseInt(localStorage.getItem(storageNames.NPS_ID)) || null,
		experienceAnswer: null,
		speedAnswer: null,
		textAnswer: null,
		loading: false
	})

	// action state
	const setLoading = boolean => {
		setNPSState({
			...NPSState,
			loading: boolean
		})
	}

	const setValue = ({ value, key }) => {
		if (!key) return new Error('useNPS setValue necesita key:string y value:number')

		setNPSState({
			...NPSState,
			[key]: value || null,
			loading: false
		})
	}

	// actions
	const setSendedValueSpeed = valueSpeed => {
		if (valueSpeed === null || !valueSpeed) return null
		if (valueSpeed >= 66) return 5
		if (valueSpeed <= 33) return 1
		return 3
	}

	// send data
	const handledSaveNPS = ({ callBack = () => { }, last = false } = {}) => {
		setLoading(true)

		const payload = {
			npsId: NPSState.npsId,
			experienceAnswer: NPSState.experienceAnswer,
			speedAnswer: setSendedValueSpeed(NPSState.speedAnswer),
			textAnswer: NPSState.textAnswer
		}

		NPSService.setNPS({ userId, payload })
			.then(res => {
				if (res.status === 200) {
					if (res.data.npsId || !last) {
						localStorage.setItem(storageNames.NPS_ID, res.data.npsId)
						setValue({ key: 'npsId', value: res.data.npsId })
					}
					callBack && callBack()
					return last && localStorage.removeItem(storageNames.NPS_ID)
				}

				return setLoading(false)
			})
			.catch(() => {
				setLoading(false)
			})
	}

	/* It is a hook that is called when the component is mounted and when NPSState.experienceAnswer
	changes to hide or not the close icon of the modal. */
	useEffect(() => {
		handleShowCloseIconModal(NPSState.experienceAnswer >= 4)
	}, [NPSState.experienceAnswer])

	const actions = {
		setValue,
		handledSaveNPS,
		handleCloseModal
	}

	return {
		...NPSState,
		...actions
	}
}
